import { LOL_PLAYERS_ROLE_ORDER } from 'app/config/videogameSpecific.config';
import { getPlayerBaseFromPlayerStat, mapPropertiesTeams } from 'app/utils/entities/match_data';

const getLolPlayerStatsLines = (
  data: PlayersStatsBlockMatch
): Record<LolPlayerRole, PlayerStatsLines<StatPlayerLol>> => {
  const opponent1Players = data?.opponents.at(0)?.stats?.players as Record<
    LolPlayerRole,
    StatPlayerLol | null
  >;
  const opponent2Players = data?.opponents.at(1)?.stats?.players as Record<
    LolPlayerRole,
    StatPlayerLol | null
  >;

  // Sort properties in this array by wanted display order
  const properties: StatProperties<StatPlayerLol>[] = [
    {
      name: 'damage_percentage',
      highlighted: 'max',
      displayFunction: value => `${Math.round(value)}%`
    },
    {
      name: 'gold_percentage',
      highlighted: 'max',
      displayFunction: value => `${Math.round(value)}%`
    },
    {
      name: 'cs_diff_at_14',
      highlighted: 'max',
      displayFunction: (val: number) => `${val > 0 ? '+' : ''}${val}`
    },
    { name: 'most_picked', display: 'hero' }
  ];

  return Object.fromEntries(
    LOL_PLAYERS_ROLE_ORDER.map(role => {
      const player1 = opponent1Players?.[role] ?? undefined;
      const player2 = opponent2Players?.[role] ?? undefined;

      return [
        role,
        {
          team1Player: getPlayerBaseFromPlayerStat(player1),
          team2Player: getPlayerBaseFromPlayerStat(player2),
          stats: mapPropertiesTeams(properties, player1, player2)
        }
      ];
    })
  ) as Record<LolPlayerRole, PlayerStatsLines<StatPlayerLol>>;
};

export { getLolPlayerStatsLines };
